import React from "react";
import { LOGO, DISCORD_URL } from "@/components/StarsBackground";

export default function Footer() {
  return (
    <footer className="relative pt-24 pb-12 border-t border-white/10 mt-10" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 relative z-10">
        <div className="grid md:grid-cols-2 gap-14 items-center">
          <div>
            <div className="flex items-center gap-4">
              <img src={LOGO} alt="" className="h-16 w-16 rounded-full ring-1 ring-white/10" />
              <div>
                <div className="font-display font-black uppercase text-2xl leading-none">
                  Rumple<span style={{ color: "var(--rv-red)" }}>{"'s"}</span> Values
                </div>
                <div className="text-xs tracking-[0.3em] text-white/40 uppercase mt-2">Cronus Zen · Apex Legends</div>
              </div>
            </div>
            <p className="text-white/55 text-sm mt-6 max-w-md leading-relaxed">
              {"Premium Apex Legends sensitivity values and GPC scripts for Cronus Zen. Built by players, trusted by the lobby."}
            </p>
          </div>
          <div className="md:text-right">
            <div className="section-label">Stay connected</div>
            <a
              href={DISCORD_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="font-display font-black uppercase block mt-4 text-3xl md:text-4xl hover:text-[var(--rv-red)] transition"
              data-testid="footer-discord-link"
            >
              Join the Discord →
            </a>
            <p className="text-white/45 text-sm mt-3">
              Support, drops, free patches, and the team.
            </p>
          </div>
        </div>

        <div className="divider-glow mt-16" />
        <div className="mt-8 flex flex-wrap items-center justify-between gap-4 text-xs text-white/40 uppercase tracking-widest">
          <div data-testid="copyright">{`© ${new Date().getFullYear()} Rumple's Values. All rights reserved.`}</div>
          <div>Cronus Zen is a trademark of Collective Minds Gaming Co. Not affiliated with EA or Respawn.</div>
        </div>
      </div>
    </footer>
  );
}
